import React from 'react';
import { useMatchViewport } from '../../hooks/use-match-viewport/index.js';
import { ActionsWrapper, ContentWrapper, EmptyStateElement, EmptyStateHeading, EmptyStateParagraph, IconWrapper, } from './empty-state.styles.js';
export const EmptyState = React.forwardRef(({ actions, content, heading, icon, ...rest }, ref) => {
    const isMobile = useMatchViewport('upTo', 'desktopMinimum');
    const headerVariant = isMobile ? '4' : '2';
    const paragraphVariant = isMobile ? 'smallCompact' : 'default';
    return (React.createElement(EmptyStateElement, { ref: ref, ...rest, isMobile: isMobile },
        icon && React.createElement(IconWrapper, null, icon),
        React.createElement(EmptyStateHeading, { elementType: 'h2', variant: headerVariant }, heading),
        typeof content === 'string' ? (React.createElement(EmptyStateParagraph, { variant: paragraphVariant }, content)) : (React.createElement(ContentWrapper, null, content)),
        actions && React.createElement(ActionsWrapper, null, actions)));
});
//# sourceMappingURL=empty-state.component.js.map